import { all, put, call, take, fork, takeLatest } from 'redux-saga/effects';
import macheteModelReady from './channels/macheteViewerChannel';
import actions from '../actions';

/**
 * Load the machete model
 * @param {*} controller - contains methods to manipulate the model, viewer and segmentation tree.
 * @param {*} action - payloads of information that send data from the store
 */
function* loadModelSaga(controller, action) {
  const { options } = action.payload;

  const model = yield call([controller, controller.loadModel], options);
  yield call([controller, controller.selectAndShowModel], model);

  yield put(actions.model.ready(model));
}

/**
 * Launches the machete model
 */
function* macheteModelReadySaga() {
  const chan = yield call(macheteModelReady);
  while (true) {
    const { model } = yield take(chan);
    yield put(actions.model.ready(model));
  }
}

/**
 * Select and show Machete Model
 * @param {*} controller - contains methods to manipulate the model, viewer and segmentation tree.
 * @param {*} action - payloads of information that send data from the store
 */
function selectAndShowModelSaga(controller, action) {
  controller.selectAndShowModel(action.payload.model);
}

/**
 * Create an instance of a machete model
 * @param {*} controller - contains methods to manipulate the model, viewer and segmentation tree.
 * @param {*} action - payloads of information that send data from the store
 */
function createModelsSaga(controller, action) {
  const { models, textures } = action.payload;
  controller.initModels(models, textures);
}

/**
 * Reset an instance of a machete model
 * @param {*} controller - contains methods to manipulate the model, viewer and segmentation tree.
 * @param {*} action - payloads of information that send data from the store
 */
function resetModelSaga(controller, action) {
  controller.resetModel(action.payload.id);
}

/**
 * Toggle the measure tool visibility
 * @param {*} controller - contains methods to manipulate the model, viewer and segmentation tree.
 */
function toggleMeasureTool(controller) {
  controller.toggleMeasureTool();
}

/**
 * Focus the machete model
 * @param {*} controller - contains methods to manipulate the model, viewer and segmentation tree.
 */
function focusSaga(controller) {
  controller.focusModel();
}

/**
 * Main Saga function for Model
 * @param {*} controller - contains methods to manipulate the model, viewer and segmentation tree.
 */
export default function* sagas(controller) {
  yield all([
    yield fork(macheteModelReadySaga),
    yield takeLatest(actions.model.focus, focusSaga, controller),
    yield takeLatest(actions.model.load, loadModelSaga, controller),
    yield takeLatest(
      actions.model.selectAndShowModel,
      selectAndShowModelSaga,
      controller,
    ),
    yield takeLatest(actions.model.createModels, createModelsSaga, controller),
    yield takeLatest(actions.model.resetModel, resetModelSaga, controller),
    yield takeLatest(
      actions.model.toggleMeasureTool,
      toggleMeasureTool,
      controller,
    ),
  ]);
}
